<template>
  <Poptip placement="right" v-model="visible">
    <div class="feedback-add">
      <Icon :size="15" type="ios-chatbubbles-outline" />
      {{ $t('payroll.detail.add_comment') }}
    </div>
    <div class="feedback-title" slot="title">
      <span>
        {{ $t('payroll.detail.comment_title') }} {{ comments.length }}
      </span>
      <Icon @click.native="visible = false" :size="16" type="md-close" />
    </div>
    <div class="feedback-content" slot="content">
      <perfect-scrollbar>
        <div class="feedback-comments" v-if="comments.length > 0">
          <div class="feedback-item" v-for="v in comments" :key="v.id">
            <div class="avatar">
              <Avatar
                :size="32"
                :style="'background: rgb(186, 217, 255)'"
                circle
              >
                {{ $substrName(v.employee.fullName) }}
              </Avatar>
            </div>
            <div class="content">
              <div class="info">
                <span class="fullName">{{ v.employee.fullName }}</span>
                <span class="createdAt">
                  {{ $moment(v.createdAt + 'Z').format('YYYY-MM-DD HH:mm') }}
                </span>
              </div>
              <p class="remark">{{ v.remark }}</p>
              <div>
                <Avatar
                  @click.native="onPreviewImage(image.key)"
                  v-for="image in v.attachments"
                  :key="image.id"
                  :src="image.key"
                  shape="square"
                  class="cup-p"
                  icon="ios-person"
                />
              </div>
            </div>
          </div>
        </div>
        <!--      无数据-->
        <div class="no-data" v-if="comments.length === 0">
          <img
            style="width: 100px"
            src="@/assets/img/no-data.png"
            alt="no-data"
          />
          <p class="b-10">
            {{ $t('i.table.noDataText') }}
          </p>
        </div>
      </perfect-scrollbar>

      <div class="feedback-footer">
        <div class="feedback-textarea">
          <Input
            :maxlength="100"
            v-model="form.remark"
            show-word-limit
            :placeholder="$t('payroll.detail.comment_input')"
          />
        </div>
        <div class="feedback-action">
          <Upload
            v-if="form.attachmentIds.length === 0"
            :on-success="fileSuccess"
            :headers="headers"
            :before-upload="handleUpload"
            :on-error="fileError"
            :on-remove="onDelFile"
            name="file"
            :show-upload-list="false"
            accept="image/jpeg, image/png, image/jpg"
            :action="`${mainApiEndpoint}/rest/api/v1/mobile/payroll_confirmations/${this.payrollConfirmationId}/add_comment_file`"
            :max-size="2048"
            :on-exceeded-size="onExceededSize"
          >
            <div class="upload">
              <img src="@/assets/img/image_icon.png" />
            </div>
          </Upload>
          <div class="fileImage" v-if="form.attachmentIds.length > 0">
            <img :src="fileUrl" />
            <div class="remove" @click="onDeleteImage">
              <Icon type="md-close-circle" />
            </div>
          </div>
          <div class="send-btn">
            <Button
              type="primary"
              :loading="sbLoading"
              :disabled="!form.remark"
              @click="onSubmit"
            >
              {{ $t('payroll.detail.send') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
    <!-- 圖片預覽 -->
    <Gallery :images="images" :index="index" @on-close="onCloseGallery" />
  </Poptip>
</template>

<script>
import app_config from '@/commons/app_config.vue';
import { AuthManage } from '@/plugins/auth';
import Gallery from '@/components/gallery.vue';

export default {
  name: 'FeedbackPoptip',
  props: ['payrollConfirmationComments', 'payrollConfirmationId'],
  components: {
    Gallery
  },
  data() {
    return {
      visible: false,
      sbLoading: false,
      mainApiEndpoint: app_config.mainApiEndpoint,
      headers: {},
      fileUrl: null,
      data: [],
      images: [],
      index: null,
      form: {
        remark: null,
        attachmentIds: []
      }
    };
  },
  computed: {
    comments() {
      return [...this.payrollConfirmationComments, ...this.data];
    }
  },
  methods: {
    onDelFile() {
      this.form.attachmentIds = [];
    },

    fileError(response, res) {
      this.$Message.error(res.message);
    },

    onExceededSize() {
      this.$Message.error(this.$t('global.img_file_text'));
    },

    fileSuccess(response) {
      this.$Message.success(this.$t('global.import_success_msg'));
      this.form.attachmentIds.push(response.id);
    },

    async handleUpload(file) {
      this.onGetFileImage(file);
      const token = AuthManage.token;
      this.headers = {
        'X-TENANT-ID': localStorage.getItem('teamId'),
        Authorization: `bearer ${token}`
      };
    },

    onGetFileImage(file) {
      const render = new FileReader();
      render.onload = (evt) => {
        this.fileUrl = evt.target.result;
      };
      render.readAsDataURL(file);
    },

    async onDeleteImage() {
      if (!this.delLoading) {
        try {
          this.delLoading = true;
          await this.$http(
            'delete',
            `mobile/payroll_confirmations/${
              this.payrollConfirmationId
            }/delete_comment_file?attachmentIds=${_.head(
              this.form.attachmentIds
            )}`,
            {},
            true
          );
        } finally {
          this.form.attachmentIds = [];
          this.fileUrl = null;
          this.delLoading = false;
        }
      }
    },

    async onSubmit() {
      if (this.form.remark) {
        try {
          this.sbLoading = true;
          const { data } = await this.$http(
            'post',
            `mobile/payroll_confirmations/${this.payrollConfirmationId}/add_comment`,
            this.form,
            true
          );
          this.data.push(data);
          this.$Message.success(this.$t('payroll.detail.comment_success'));
        } finally {
          this.sbLoading = false;
          this.form.remark = null;
          this.form.attachmentIds = [];
        }
      }
    },

    onCloseGallery() {
      this.index = null;
      setTimeout(() => {
        this.visible = true;
      }, 50);
    },

    onPreviewImage(url) {
      this.images = [url];
      this.index = 0;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-poptip {
  &-body {
    padding: 0;
  }

  &-title {
    padding: 0;
  }

  &-title:after {
    display: none;
  }
}

.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
}

.upload {
  img {
    width: 24px;
    height: 24px;
  }

  cursor: pointer;
}

.upload:hover {
  opacity: 0.6;
}

.fileImage {
  width: 26px;
  height: 26px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .remove {
    position: absolute;
    top: -10px;
    color: red;
    right: -10px;
    cursor: pointer;
  }
}

.cup-p {
  cursor: pointer;
}

.cup-p:hover {
  opacity: 0.6;
}

.feedback {
  &-title {
    font-weight: 500;
    font-size: 16px;
    padding: 14px;
    color: #1f2329;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    .ivu-icon-md-close:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }

  &-add {
    cursor: pointer;
    padding: 1px 2px;
    border-radius: 4px;
  }

  &-add:hover {
    background-color: #f7f8fa;
  }

  &-content {
    width: 375px;
  }

  &-comments {
    height: 406px;
    padding-bottom: 26px;
  }

  &-item {
    display: flex;
    gap: 8px;
    padding: 0 14px;
    margin-bottom: 26px;

    .content {
      flex: 1;

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .fullName {
          font-weight: 500;
          font-size: 14px;
          color: #1f2329;
        }

        .createdAt {
          font-weight: 400;
          font-size: 12px;
          color: #858d99;
        }
      }

      .remark {
        margin-top: 6px;
        font-weight: 400;
        font-size: 14px;
        color: #1f2329;
      }
    }
  }

  &-footer {
    padding: 8px 14px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.05);
  }

  &-action {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .send-btn {
      button {
        min-width: 56px;
        height: 26px;
        border-radius: 32px;
      }
    }
  }
}
</style>
